var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaiterOnWayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50%",
    height: "50%",
    viewBox: "0 0 75 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.1875 10.1221V7.40625H44.5312C45.8262 7.40625 46.875 6.35742 46.875 5.0625V2.71875C46.875 1.42383 45.8262 0.375 44.5312 0.375H30.4688C29.1738 0.375 28.125 1.42383 28.125 2.71875V5.0625C28.125 6.35742 29.1738 7.40625 30.4688 7.40625H32.8125V10.1221C16.9175 12.4028 4.6875 26.0361 4.6875 42.5625H70.3125C70.3125 26.0361 58.0825 12.4028 42.1875 10.1221ZM72.6562 47.25H2.34375C1.04883 47.25 0 48.2988 0 49.5938V54.2812C0 55.5762 1.04883 56.625 2.34375 56.625H72.6562C73.9512 56.625 75 55.5762 75 54.2812V49.5938C75 48.2988 73.9512 47.25 72.6562 47.25Z",
    fill: "#E2ABB1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiterOnWayIcon);
export default __webpack_public_path__ + "static/media/WaiterOnWayIcon.fe7dd58b.svg";
export { ForwardRef as ReactComponent };